export default __webpack_public_path__ + "static/roche-13eebd283d143ec6c9b33a1fc26bf495.png";